var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        "class-name": " app-modal",
        "footer-hide": "",
        width: "600rem",
        closable: false,
      },
      on: { "on-visible-change": _vm.handleVisibleChange },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "c-interactive-panel",
        {
          staticClass: "sign-up steam-trade-url-modal",
          attrs: { title: "绑定Steam交易连接", has_close_button: "" },
          on: { close_button_click: _vm.close },
        },
        [
          _c("div", { staticClass: "sign-up__content" }, [
            _c("label", { staticClass: "sign-up__field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localUrl,
                    expression: "localUrl",
                  },
                ],
                staticClass: "sign-up__field__input",
                attrs: {
                  type: "text",
                  placeholder: "请输入您的STEAM交易连接(24小时内不可修改)",
                  autocomplete: "off",
                },
                domProps: { value: _vm.localUrl },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.localUrl = $event.target.value
                  },
                },
              }),
            ]),
            _c("p", [_vm._v("国内用户访问Steam时，需使用网络加速器")]),
            _c("p", [
              _c("span", { staticClass: "url_text" }, [
                _vm._v("建议使用网易UU加速器，可前往"),
              ]),
              _c(
                "a",
                {
                  attrs: {
                    href: "https://uu.163.com/?from=global",
                    target: "_blank",
                    rel: "noreferrer",
                  },
                },
                [_vm._v("网易UU官网")]
              ),
              _vm._v("下载 "),
            ]),
            _c(
              "p",
              { staticClass: "setting-form__text setting-form__text_active" },
              [
                _c("i", { staticClass: "ivu-icon ivu-icon-ios-alert-outline" }),
                _vm._v(" 请确认您的报价链接有效，并且设置Steam库存公开。 "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://steamcommunity.com/id/me/tradeoffers/privacy#trade_offer_access_url",
                      target: "_blank",
                    },
                  },
                  [_vm._v("点击STEAM获取交易连接")]
                ),
              ]
            ),
            _c(
              "label",
              { staticClass: "sign-up__field steam-verification-field" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.verification.passCode,
                      expression: "verification.passCode",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "sign-up__field__input",
                  attrs: {
                    type: "text",
                    inputmode: "numeric",
                    placeholder: "请输入验证码",
                    autocomplete: "off",
                  },
                  domProps: { value: _vm.verification.passCode },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.verification,
                        "passCode",
                        $event.target.value.trim()
                      )
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _c(
                  "button",
                  {
                    staticClass: "steam-verification-field__button",
                    attrs: {
                      type: "button",
                      disabled:
                        _vm.loading ||
                        _vm.verification.codeLoading ||
                        !!_vm.verification.countdownTimer,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.getTradeUrlCode.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm.verification.countdownTimer
                      ? _c("span", [
                          _vm._v(
                            "重新获取(" +
                              _vm._s(_vm.verification.countdown) +
                              "秒)"
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.verification.codeLoading
                                ? "发送中"
                                : "获取验证码"
                            )
                          ),
                        ]),
                  ]
                ),
              ]
            ),
            !_vm.loading
              ? _c(
                  "div",
                  {
                    staticClass: "submit-button",
                    staticStyle: { width: "100%", "margin-top": "10px" },
                    on: { click: _vm.setTradeUrl },
                  },
                  [_vm._v(" 确认绑定 ")]
                )
              : _c(
                  "div",
                  {
                    staticClass: "submit-button",
                    staticStyle: { width: "100%", "margin-top": "10px" },
                  },
                  [
                    _c("i", {
                      staticClass: "ivu-icon ivu-icon-md-sync pay-loding-ico",
                    }),
                    _vm._v("作业中,请稍后 "),
                  ]
                ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }